import React from "react";
import Header from "../header";
import { apiCall_domain } from "../api";
import axios from "axios";
import { createGlobalStyle } from "styled-components";
import SimpleReactValidator from "simple-react-validator";
import PulseLoader from "react-spinners/PulseLoader";

class ChangePass extends React.Component {
  state = {
    oldPass: "",
    newPass: "",
    newPassRetry: "",
    error: "",
    inputValues: [],
    loading: false,
  };
  constructor() {
    super();
    this.validator = new SimpleReactValidator({
      className: "danger error",
      messages: {
        required: "این فیلد نباید خالی باشد",
        min: "رمز عبور نمی تواند کمتر از 8 کاراکتر باشد",
        max: "رمز عبور نمی تواند بیشتر از 18 کاراکتر باشد",
      },
      validators: {
        sameAsConfirmPass: {
          message: "رمز عبور با تکرار آن برابر نیست",
          rule: () => {
            if (
              this.state.inputValues.newPass !==
              this.state.inputValues.newPassRetry
            ) {
              return false;
            }
            return true;
          },
        },
      },
      autoForceUpdate: this,
    });
  }
  componentDidMount() {
    if (!localStorage.getItem("Api_key")) {
      this.props.history.push("/");
    }
  }
  setinputValues = (e) => {
    this.setState({
      inputValues: {
        ...this.state.inputValues,
        [e.currentTarget.name]: e.currentTarget.value,
      },
      error: "",
    });
  };
  handleSubmit = (e) => {
    if (this.validator.allValid()) {
      this.setState({ loading: true });
      {
        const Data = {
          old_password: this.state.oldPass,
          new_password: this.state.newPass,
        };
        const headers = {
          Authorization: localStorage.getItem("Api_key"),
          "content-type": "application/json",
        };
        axios
          .post(`${apiCall_domain}/customer/user/change-password`, Data, {
            headers: headers,
          })
          .then((res) => {
            localStorage.setItem("Api_key", res.data.api_key);
            this.props.history.push("/profile");
            this.setState({ loading: true });
          })
          .catch((error) => {
            if (error.response) {
              this.setState({
                error: "کلمه عبور فعلی اشتباه است ",
                loading: false,
              });
            }
          });
      }
    } else {
      this.validator.showMessages();
    }
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #fafafa !important;
    }`;

    return (
      <>
        <GlobalStyles />
        <main className="EnterPass">
          <Header
            showSearchBar={true}
            title={"تغییر رمز عبور"}
            backUrl={"/profile"}
            isDarkTheme={true}
          />
          <div className="phoneBox">
            <input
              type="password"
              name="pass"
              className="input newPass"
              placeholder="کلمه عبور"
              onChange={this.setinputValues}
            />
            {this.validator.message(
              "pass",
              this.state.inputValues.pass,
              "required",
            )}
            <input
              type="password"
              name="newPass"
              className="input newPass2"
              placeholder=" کلمه عبور جدید"
              onChange={this.setinputValues}
            />
            {this.validator.message(
              "newPass",
              this.state.inputValues.newPass,
              "required|min:8|max:18",
            )}
            <input
              type="password"
              name="newPassRetry"
              className="input newPassRetry"
              placeholder=" تکرار کلمه عبور جدید"
              onChange={this.setinputValues}
            />
            {this.validator.message(
              "newPassRetry",
              this.state.inputValues.newPassRetry,
              "required|sameAsConfirmPass",
            )}
            <div className="error">{this.state.error}</div>
          </div>
          <div className="mySecContinue changePassContinue">
            {this.state.loading ? (
              <button className="btn disabled">
                <PulseLoader size={12} color="#fff" loading={true} />
              </button>
            ) : (
              <button onClick={(e) => this.handleSubmit(e)}>
                تغییر رمز عبور
              </button>
            )}
          </div>
        </main>
      </>
    );
  }
}
export default ChangePass;
